// extracted by mini-css-extract-plugin
export var summaryDate = "_4w-0";
export var summaryInfo = "_4w-1";
export var summaryInfoSection = "_4w-2";